import { createContext, useState } from 'react';

type TMessageContext = {
    activeRoomId: string | null;
    setActiveRoomId: (roomId: string | null) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
    message: string;
    setMessage: (message: any) => void;
    setLimit: (number: number) => void;
    limit: number;
    setPage: (number: number) => void;
    page: number;
    setSearchTerm: (term: string) => void;
    searchTerm: string;
};

export const MessageContext = createContext({
    activeRoomId: '',
    setActiveRoomId: () => {},
    isLoading: false,
    setIsLoading: () => {},
    message: '',
    setMessage: () => {},
    limit: 10,
    page: 1,
    setPage: () => {},
    setSearchTerm: () => {},
    searchTerm: '',
    setLimit: () => {},
} as TMessageContext);

export const MessageContextProvider = ({ children }: any) => {
    const [activeRoomId, setActiveRoomId] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const msgValue = {
        message,
        setMessage,
        isLoading,
        setIsLoading,
        activeRoomId,
        setActiveRoomId,
        setLimit,
        limit,
        page,
        setPage,
        setSearchTerm,
        searchTerm,
    };

    return <MessageContext.Provider value={msgValue}>{children}</MessageContext.Provider>;
};
